import script from "./userAccounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./userAccounts.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__